import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService, ModalOptions} from 'ngx-bootstrap/modal';
import {ActivatedRoute} from "@angular/router";
import { LoadingService } from 'src/app/services/loading/loading.service';
import { DocuSignService } from 'src/app/services/docusign-service/docusign-service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


@Component({
    selector: 'docusign-callback',
    templateUrl: './docusign-callback.component.html',
    standalone: false
})
  export class DocuSignCallBackComponent implements OnInit {

    constructor(public bsModalRef: BsModalRef, private modalService: BsModalService, private loader: LoadingService){

    }

    ngOnInit(): void {
        window.parent.postMessage('docusign-complete', '*');
    }
  }